<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10CWnER/tc-custom/9781466827813.jpg?1732049725650" alt="This image is the cover for the book Corpse de Ballet, Nine Muses Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Corpse de Ballet, Nine Muses Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Fast, witty, and literate, <i>Corpse de Ballet </i>marks the dazzling debut of the Nine Muses Mysteries featuring Juliet Bodine and Murray Landis.</b><br/><br/>It's not as if Juliet Bodine wishes that she'd stayed an English professor instead of becoming a successful romance novelist. It's just that writing, though interesting, is never easy, and she will do almost anything to avoid her desk. So she succumbs to the pleas of her friend Ruth, a renowned choreographer, to help translate Dickens' <i>Great Expectations</i> into ballet form.<br/><br/>Watching the magnificent dancers work is fascinating. But Juliet soon finds the company plagued by jealousies, subterranean liaisons, ugly sabotage, and-sudden death. <br/><br/>Could it be murder? <br/><br/>NYPD detective Murray Landis is skeptical. But Juliet-who is startled to recognize in Murray the budding sculptor who dated her college roommate years ago-disagrees, and turns her novelist's sense of plot and character to detection. Can she and Murray unmask the ruthless choreographer of a pas de death?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellen Pall
      </h2>
      
      <p class="authorDescription body article"><P><B>Ellen Pall</B>, a novelist whose prose has been praised as "precise, shrewd, and brightly amusing" (<I>Kirkus Reviews</I>), with sentences that are "good enough to eat" (<I>The New Yorker</I>), is the author of <I>Back East </I>and <I>Among the Ginzburgs</I>; she has also written many Regency romances under the pen name Fiona Hill. As a freelance journalist, she has written extensively on people in the arts for <I>The New York Times </I>and other publications. Slightly Abridged is the second in her Nine Muses Mysteries series. She lives in Manhattan with her husband and son.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Paperbacks
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?96ebc4ca